import { FC } from "react";
import { pluralize } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const DocumentBulkEntityCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { selectedDocumentCount = 0, documentBulkEntityOptions = [] } =
        options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set entity for ${selectedDocumentCount} ${pluralize("document", selectedDocumentCount)}`}
            options={documentBulkEntityOptions}
        />
    );
};
